import React from 'react';
import GenericPullAndPushToolView from '../GenericPullAndPushToolView';
import WizCredentialsForm from './WizCredentialsForm';
import WizConfigListing from './WizConfigListing';

const WizPullAndPushView = (props) => {
    return (
        <GenericPullAndPushToolView 
            {...props}
            PullCredentialForm={WizCredentialsForm}
            PullConfigListingView={WizConfigListing}
        />
    );
}

export default WizPullAndPushView;